
export default {
  state: {
    permissions: [],
    roles: [],
    company: {},
    data: {
      company_id: "",
      id: "",
      email: "",
      firstName: "",
      lastName: "",
      expired: false
    },
    defaultCompanyId: "",
    selected_company_id: "",
    companies: [],
    products: [],
    // Durable user preferences (persisted to localStorage). These survive page
    // reloads and tab close, unlike the session store.
    preferences: {
      // Places experience mode for the Select Places step: 'old' (Classic) or
      // 'new' (Builder). Defaults to Classic when the user has made no choice.
      placesExperienceMode: "old",
      // Last Source the user selected in the Places page / Place Selection
      // modal: 'Azira' or 'Custom'. Used as the default Source the next time
      // either view is opened. Defaults to 'Azira'.
      lastSelectedSource: "Azira",
    },
  },
  mutations: {
    // Persist the user's Places experience-mode preference. Only the two valid
    // values are stored; anything else falls back to 'old' (Classic).
    setPlacesExperienceMode(state, mode) {
      if (!state.preferences) {
        state.preferences = { placesExperienceMode: "old" };
      }
      state.preferences.placesExperienceMode = mode === "new" ? "new" : "old";
    },
    // Persist the user's last-selected Source. Only the two valid values are
    // stored; anything else falls back to 'Azira'.
    setLastSelectedSource(state, source) {
      if (!state.preferences) {
        state.preferences = { placesExperienceMode: "old", lastSelectedSource: "Azira" };
      }
      state.preferences.lastSelectedSource = source === "Custom" ? "Custom" : "Azira";
    },
    setPermissions(state, payload) {
      const roles = [];
      const permissions = [];
      //console.log(payload)
      for (const role of payload) {
        roles.push({
          id: role.id,
          name: role.name
        });
        for (const permission of role.permissions) {
          permissions.push(permission);
        }
        
      }
      state.roles = roles;
      state.permissions = permissions;
    },
    setCompany(state,payload) {
      state.company = payload;
    },
    setData(state,payload) {
      state.data.company_id = payload.company_id;
      state.data.id = payload.id;
      state.data.email = payload.email;
      state.data.firstName = payload.firstName || "";
      state.data.lastName = payload.lastName || "";
    },
    setExpired(state, payload) {
      state.data.expired = payload;
    },
    setDefaultCompanyId(state, payload) {
      state.defaultCompanyId = payload;
    },
    setSelectedCompanyId(state, payload) {
      state.selected_company_id = payload;
    },
    setCompanies(state, payload) {
      state.companies = payload;
    },
    setProducts(state, payload) {
      state.products = payload;
    },
  },
};
